import createUseCase from "./ComplementaryProductsGalleryUseCase";
import createComplementaryProductsComponent from "../../components/ComplementaryProducts/ComplementaryProducts";
import createComplementaryProductsAnchor from "../MainBlock/ComplementaryProductsAnchor"

const init = (complementaryProductsServiceClient, templateContext) => {
  const complementaryProductsTargetContainer = document.querySelector("#pdp-complementary-products");
  const {productCode: parentProductCode} = templateContext;
  const complementaryProductsComponent = createComplementaryProductsComponent(complementaryProductsTargetContainer);
  const complementaryProductsAnchor = createComplementaryProductsAnchor();

  const useCase = createUseCase(complementaryProductsServiceClient, complementaryProductsAnchor, complementaryProductsComponent);
  useCase.handleInitialPageLoad(parentProductCode);
};

export default {init};
